import React, { useContext } from 'react';
import { useStyletron } from 'baseui';
import { MerchantContext, MERCHANT_TYPES } from 'commons-ui';
import logo from './assets/zupee.png';
import InternalLogin from './InternalLogin';
import ExternalLogin from './ExternalLogin';

const Login: React.FC<{}> = () => {
	const { merchantName } = useContext(MerchantContext);

	const isExternal = merchantName === MERCHANT_TYPES.EXTERNAL; // use merchant context here
	const [css] = useStyletron();

	return (
		<div
			className={css({
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				height: '100%',
				width: '100%'
			})}>
			<div
				className={css({
					display: 'flex',
					justifyContent: 'space-around',
					width: '100%'
				})}>
				<div
					className={css({
						display: 'flex',
						justifyContent: 'space-around',
						flexDirection: 'column'
					})}>
					<div>
						<h1
							className={css({
								textAlign: 'center',
								marginBottom: '20%'
							})}>
							CRM DASHBOARD
						</h1>
					</div>
					<div>
						<img src={logo} alt='zupee-logo' height='200px' />
					</div>
				</div>
				<div
					className={css({
						height: '400px',
						borderLeft: '1px solid black'
					})}
				/>
				<div
					className={css({
						display: 'flex',
						justifyContent: 'space-around',
						flexDirection: 'column'
					})}>
					<div>{isExternal ? <ExternalLogin /> : <InternalLogin />}</div>
				</div>
			</div>
		</div>
	);
};

export default Login;
